import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 과목 교사 메인 페이지.
 * 원본 전체 구현은 SubjectTeacherPage.full.tsx 에 있으며,
 * 빌드 호환성 문제로 임시 단순 버전 사용 중.
 */
const SubjectTeacherPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ marginBottom: 16 }}>과목 교사</h1>
      <p style={{ marginBottom: 16 }}>
        <button
          type="button"
          onClick={() => navigate('/subject/teacher/SubjectTeacherHome')}
          style={{ padding: '8px 16px', cursor: 'pointer' }}
        >
          과목 교사 홈으로
        </button>
      </p>
      <p style={{ color: '#666', fontSize: 14 }}>
        전체 기능은 SubjectTeacherPage.full.tsx 복구 후 사용 가능합니다.
      </p>
    </div>
  );
};

export default SubjectTeacherPage;
